import styled, {css} from 'styled-components'

export const StyledCategory = styled.span(
    ({theme: {palette}}) => css`
        color: ${palette.neutral[700]};
    `
)
